import React from "react";
import { PhoneOutlined, InstagramOutlined,WhatsAppOutlined,MailOutlined,LinkedinOutlined } from '@ant-design/icons';

const Contact = () =>{
    return (
        <div className="contact-section" id="contact_section">
            <div className="section-padding text-center">
                <h4 className="section-title">Contact</h4>
                <div className="max-width-700">
                    <p>If you have any questions, please feel free to contact me. If you don't get an answer immediately,I'll get back to you as soon as possible.</p>                
                </div>
                <br/>
                <div className="contact-row"><label>Telephone: </label> <a href="tel:+989374755674">+989374755674</a></div>
                <div className="contact-row"><label>Email: </label> <a href="mailto:samran.f.m@gmail.com">samran.f.m@gmail.com</a></div>
                <br/>
                <a href="#" className="social-link-item" target="_blank">
                    <InstagramOutlined />
                </a>
                <a href="#" className="social-link-item" target="_blank">
                    <WhatsAppOutlined />
                </a>
                <a href="#" className="social-link-item" target="_blank">
                    <LinkedinOutlined />
                </a>               
            </div>
        </div>
    )
}

export default Contact;